import React from 'react'
import { t, Trans } from '@lingui/macro'
import WhatIsYotiHeader from './WhatIsYotiHeader'
import WhatIsYotiPoints from './WhatIsYotiPoints'

import './WhatIsYoti.scss'

const ICON_LIST_HEADING = t`What you can do with your Digital ID`

const WhatIsYoti = () => (
  <div className="what-is-yoti">
    <WhatIsYotiHeader />
    <h5><Trans id={ICON_LIST_HEADING} /></h5>
    <WhatIsYotiPoints />
  </div>
)

export default WhatIsYoti
